import { Text } from '@rsos/base-components';
import { ResourceOption } from '../types';
import {
  StyledResourceOptionCard,
  IconContainer,
  CardContent,
} from './ResourceRequestPanel.styles';

interface ResourceOptionCardProps {
  option: ResourceOption;
  onClick: () => void;
}

/**
 * Individual resource option card displayed in the ResourceRequestPanel.
 * Shows an icon, title, source, and description for each resource type.
 */
const ResourceOptionCard = ({ option, onClick }: ResourceOptionCardProps) => {
  const { Icon, title, source, description } = option;

  return (
    <StyledResourceOptionCard
      onClick={onClick}
      data-name={`resource-option-${option.id}`}
    >
      <IconContainer>
        <Icon color="primaryText" height={16} width={16} />
      </IconContainer>
      <CardContent>
        <Text
          color="primaryText"
          fontWeight="bold"
          size="normal"
          lineHeight="1.2"
          data-name={`resource-option-title-${option.id}`}
        >
          {title}
        </Text>
        <Text
          color="secondaryText"
          size="small"
          lineHeight="1.2"
          data-name={`resource-option-source-${option.id}`}
        >
          {source}
        </Text>
        <Text
          color="secondaryText"
          size="small"
          marginTop="4px"
          data-name={`resource-option-description-${option.id}`}
        >
          {description}
        </Text>
      </CardContent>
    </StyledResourceOptionCard>
  );
};

export default ResourceOptionCard;
